import "./RequestTax.css";
import React, { useState, useEffect, useRef } from "react";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import usePersistedState from "../../../hooks/usePersistedState";
import { getDashboard } from "../../../redux/actions/fluxoNSimilar";
import HeadingDashboard from "../../fluxo-engenheiro/heading/headingDashboard";
import CardDashboard from "../../fluxo-engenheiro/CardDashboard/CardDasboard";
import iconAnswer from "../../../assets/svgs/iconAnswer.svg";
import IconAnswerDashboard from "../../iconeAnswer/iconAnswerDashboard";
import { SkeletonWrapper } from "../../../componentes/SkeletonWrapper/sleketonWrapper";
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
} from "recharts";

import { Tooltip as MuiTooltip } from "@mui/material";
import { capitalizeFirstLetter } from "../../../utils/formatStrings";

export const DashboardTax = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [materialPartNumber, setMaterialPartNumber] = usePersistedState(
    "materialPartNumber",
    "",
  );
  const [materialPartDesc, setMaterialPartDesc] = usePersistedState(
    "materialPartDesc",
    "",
  );
  const [centerFilter, setCenterFilter] = usePersistedState("centerFilter", "");
  const [emitentePartNumber, setEmitentePartNumber] = usePersistedState(
    "emitentePartNumber",
    "",
  );
  const [startDate, setStartDate] = usePersistedState("startDate", "");
  const [endDate, setEndDate] = usePersistedState("endDate", "");

  const [showMessage, setShowMessage] = useState(false);
  const [showMessageFav, setShowMessageFav] = useState(false);

  const handleFilter = async () => {
    setLoading(true);
    await dispatch(
      getDashboard({
        emitter: emitentePartNumber.toString(),
        startDate,
        endDate,
      }),
    ).finally(() => setLoading(false));
  };

  useEffect(() => {
    dispatch(
      getDashboard({
        emitter: emitentePartNumber.toString(),
        startDate,
        endDate,
      }),
    ).finally(() => setLoading(false));
  }, []);

  const { sessionDashboard } = useSelector(
    (state: RootState) => state.sessionClassifications,
  );

  const handleClick = () => {
    setShowMessage((prev) => !prev);
  };

  const handleClickFav = () => {
    setShowMessageFav((prev) => !prev);
  };

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      setShowMessage(false);
      setShowMessageFav(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  const message = `
  <strong>Este indicador de desempenho (KPI) é calculado assim:</strong>
  <p>(Total PNs classificados - Total de PNs corrigidos) / Total PNs classificados.</p>
`;

  const messageFav = `
<strong>Este indicador de desempenho (KPI) é calculado assim:</strong>
<p>Total PNs classificados com fluxo do favorito/Total PNs classificados..</p>
`;

  const colorMap: Record<string, string> = {
    "RFB 1": "#007BC0",
    "RFB 2": "#005587",
    "RFB 3": "#0096e8",
    "RFB 4": "#003e64",
    "RFB 5": "#9dc9ff",
    "Auditoria 1": "#2E908B",
    "Auditoria 2": "#116864",
    "Auditoria 3": "#B12EA9",
    "Auditoria 4": "#791D73",
    "Auditoria 5": "#219557",
    "Auditoria 6": "#006c3a",
    "Auditoria 7": "#e5a2df",
    "Auditoria 8": "#c535bc",
    "Auditoria 9": "#f0dcee",
    "Auditoria inconclusiva": "#d1e4ff",
  };

  const tagColors: Record<string, string> = {
    "Bosch Cases": "#007BC0",
    "Fluxo IA": "#00629A",
    "Fluxo Favorito": "#56B0FF",
    "Não definido": "#004975",
  };

  const data02 = sessionDashboard?.classificationPerFlag.map((item: any) => {
    const flag = capitalizeFirstLetter(item.flag);
    return {
      name: flag,
      value: item.totalFlag,
      color: colorMap[flag] || "#ccc",
    };
  });

  const generateBlueShade = (index: number, total: number) => {
    const hue = 210;
    const saturation = 70;
    const lightness = 35 + (index / total) * 40;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };

  const dataReason = sessionDashboard?.classificationPerReasonDescription.map(
    (item: any, index: number) => ({
      name: item.reason,
      value: item.total,
      color: generateBlueShade(
        index,
        sessionDashboard?.classificationPerReasonDescription.length,
      ),
    }),
  );

  const dataPie = sessionDashboard?.classificationPerTag.map((item: any) => ({
    name: item.tag,
    value: item.totalClassified,
    color: tagColors[item.tag] || "#CCCCCC", // cor padrão fallback
  }));

  const manualData = [{}];
  const dataFromAPI =
    sessionDashboard?.classificationPerCenter?.map((item: any) => ({
      name: item.center,
      total: item.total,
    })) || [];

  const data = [...dataFromAPI, ...manualData];

  const monthMap: { [key: string]: string } = {
    "01": "Jan",
    "02": "Fev",
    "03": "Mar",
    "04": "Abr",
    "05": "Mai",
    "06": "Jun",
    "07": "Jul",
    "08": "Ago",
    "09": "Set",
    "10": "Out",
    "11": "Nov",
    "12": "Dez",
  };

  const dataClassifications = sessionDashboard?.classifications
    ?.map((item: any) => {
      if (item?.day) {
        return {
          name: item.day, // Ex: "03/07"
          total_classificações: item.totalClassifications,
        };
      }

      if (item?.month) {
        const [month, year] = item.month.split("/");
        return {
          name: `${monthMap[month]}/${year}`, // Ex: "Jul/2025"
          total_classificações: item.totalClassifications,
        };
      }

      return null;
    })
    .filter(Boolean);

  const chartWidth = data?.length > 8 ? data?.length * 100 : "100%";
  const chartWidthClassifications =
    dataClassifications?.length > 8
      ? dataClassifications?.length * 100
      : "100%";

  const maxValue =
    Array.isArray(dataClassifications) && dataClassifications.length > 0
      ? Math.max(
          ...dataClassifications.map((item) => item.total_classificações || 0),
        )
      : 0;

  const isSmallRange = maxValue <= 1;

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <div style={{ height: "100%" }}>
      <SkeletonWrapper loading={loading} />

      {!loading && (
        <>
          <div className="containerHomePage">
            <HeadingDashboard
              titlePage="Dashboard de Análise de Classificação"
              filtros="sim"
              blockText="sim"
              materialPartDesc={materialPartDesc}
              setMaterialPartDesc={setMaterialPartDesc}
              centerFilter={centerFilter}
              setCenterFilter={setCenterFilter}
              setMaterialPartNumber={setMaterialPartNumber}
              materialPartNumber={materialPartNumber}
              emitentePartNumber={emitentePartNumber}
              setEmitentePartDesc={setEmitentePartNumber}
              setStartDate={setStartDate}
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              handleFilter={handleFilter}
            />
          </div>

          <div className="containerRequest">
            <div className="containerCards">
              <div style={{ width: "24%" }}>
                <CardDashboard
                  titleStatus="Part Numbers Corrigidos"
                  qtyCard={sessionDashboard?.correctedPartNumbers}
                />
              </div>
              <div style={{ width: "24%" }}>
                <CardDashboard
                  titleStatus="Part Numbers Classificados"
                  qtyCard={sessionDashboard?.classificatedPartNumbers}
                />
              </div>
              <div style={{ width: "24%", position: "relative" }}>
                <>
                  <CardDashboard
                    titleStatus="Acurácia"
                    qtyCard={sessionDashboard?.accuracyByAdmTxrValidation}
                    icon={iconAnswer}
                    handleClick={handleClick}
                    ref={containerRef}
                  />
                  {showMessage && <IconAnswerDashboard message={message} />}
                </>
              </div>
              <div style={{ width: "24%", position: "relative" }}>
                <>
                  <CardDashboard
                    titleStatus="Percent. utilização do Favorito"
                    qtyCard={sessionDashboard?.usageOfFavoritePartNumber}
                    icon={iconAnswer}
                    handleClick={handleClickFav}
                    style="wrap_text"
                    ref={containerRef}
                  />
                  {showMessageFav && (
                    <IconAnswerDashboard message={messageFav} />
                  )}
                </>
              </div>
            </div>
          </div>

          <div className="containerGraphs">
            <div
              style={{
                width: "calc(100% - 55px)",
                marginBottom: 15,
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  width: "49%",
                  marginRight: 15,
                  height: 380,
                  display: "flex",
                  position: "relative",
                  float: "left",
                  marginBottom: 15,
                  paddingTop: "50px",
                }}
              >
                <div className="title_dash">
                  <h2>Flags</h2>
                </div>

                {Array.isArray(data02) && data02.length > 0 ? (
                  <div className="chartLegendLayout">
                    <div className="chartLegendChartArea">
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart width={400} height={340}>
                          <Pie
                            data={data02}
                            dataKey="value"
                            cx="50%"
                            cy="50%"
                            innerRadius={65}
                            outerRadius={110}
                            label
                          >
                            {data02?.map(
                              (entry: { color: string | undefined }) => (
                                <Cell
                                  key={`cell-${entry.color}`}
                                  fill={entry.color}
                                />
                              ),
                            )}
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="chartLegendPanel">
                      <ul className="chartLegendList">
                        {data02?.map((item: any, index: number) => {
                          const isLong = item.name?.length > 24;
                          const label = truncateText(item.name, 24);

                          return (
                            <li
                              key={`${item.name}-${index}`}
                              className="chartLegendItem"
                            >
                              <div
                                className="chartLegendDot"
                                style={{ backgroundColor: item.color }}
                              />
                              {isLong ? (
                                <MuiTooltip title={item.name} arrow>
                                  <span className="chartLegendLabel">
                                    {label}
                                  </span>
                                </MuiTooltip>
                              ) : (
                                <span className="chartLegendLabel">{label} — <strong>{item.value}</strong></span>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                ) : (
                  <p className="no_results">Nenhum resultado encontrado.</p>
                )}
              </div>
              <div
                style={{
                  background: "#fff",
                  width: "49%",
                  height: 380,
                  display: "flex",
                  position: "relative",
                  float: "left",
                  marginBottom: 15,
                  paddingTop: "50px",
                }}
              >
                <div className="title_dash">
                  <h2>Fluxo da IA</h2>
                </div>

                {Array.isArray(dataPie) && dataPie.length > 0 ? (
                  <>
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart width={400} height={400}>
                        <Pie
                          dataKey="value"
                          isAnimationActive={false}
                          data={dataPie}
                          cx="50%"
                          cy="50%"
                          outerRadius={110}
                          label
                        >
                          {dataPie?.map((entry: any) => (
                            <Cell
                              key={`cell-${entry.color}`}
                              fill={entry.color}
                            />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                    <div
                      style={{
                        width: "55%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      {dataPie?.map((entry: any) => (
                        <div
                          key={entry.color}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 8,
                          }}
                        >
                          <div
                            style={{
                              width: 12,
                              height: 12,
                              backgroundColor: entry.color,
                              marginRight: 8,
                              borderRadius: "50%",
                            }}
                          />
                          <span style={{ fontSize: 14 }}>
                            {entry.name} — <strong>{entry.value}</strong>
                          </span>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <p className="no_results">Nenhum resultado encontrado.</p>
                )}
              </div>

              <div
                style={{
                  background: "#fff",
                  width: "49%",
                  height: 380,
                  display: "flex",
                  position: "relative",
                  float: "left",
                  marginRight: 15,
                  marginBottom: 15,
                  paddingTop: "70px",
                }}
              >
                <div className="title_dash">
                  <h2> Justificativa de reclassificação</h2>
                </div>

                {Array.isArray(dataReason) && dataReason.length > 0 ? (
                  <>
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart width={400} height={400}>
                        <Pie
                          dataKey="value"
                          isAnimationActive={false}
                          data={dataReason}
                          cx="50%"
                          cy="50%"
                          outerRadius={110}
                          label
                        >
                          {dataReason?.map((entry: any) => (
                            <Cell
                              key={`cell-${entry.color}`}
                              fill={entry.color}
                            />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                    <div
                      style={{
                        width: "55%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      {dataReason?.map((entry: any) => {
                        const isLong = entry.name?.length > 30;
                        const content = (
                          <div
                            key={entry.color}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: 8,
                            }}
                          >
                            <div
                              style={{
                                width: 12,
                                height: 12,
                                backgroundColor: entry.color,
                                marginRight: 8,
                                borderRadius: "50%",
                              }}
                            />
                            <span style={{ fontSize: 14 }}>
                              {truncateText(entry.name, 30)} —{" "}
                              <strong>{entry.value}</strong>
                            </span>
                          </div>
                        );

                        return isLong ? (
                          <MuiTooltip title={entry.name} key={entry.color}>
                            {content}
                          </MuiTooltip>
                        ) : (
                          <React.Fragment key={entry.color}>
                            {content}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <p className="no_results">Nenhum resultado encontrado.</p>
                )}
              </div>

              <div
                style={{
                  background: "#fff",
                  width: "49%",
                  height: 380,
                  position: "relative",
                  paddingTop: "70px",
                  float: "left",
                  marginBottom: 15,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    overflowX: "auto",
                    overflowY: "hidden",
                    height: "100%",
                    float: "left",
                  }}
                >
                  <div className="title_dash">
                    <h2>Classificações Totais</h2>
                  </div>
                  <div
                    style={{
                      width: chartWidthClassifications,
                      height: "100%",
                      display: "flex",
                    }}
                  >
                    {Array.isArray(dataClassifications) &&
                    dataClassifications.length > 0 ? (
                      <ResponsiveContainer width="100%" height={350}>
                        <BarChart
                          data={dataClassifications}
                          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                        >
                          <CartesianGrid horizontal={true} vertical={false} />
                          <XAxis dataKey="name" />
                          <YAxis
                            domain={
                              isSmallRange
                                ? [0, 3]
                                : [
                                    0,
                                    (dataMax: number) =>
                                      Math.ceil(dataMax + dataMax * 0.05),
                                  ]
                            }
                          />

                          <Tooltip />
                          <Bar
                            dataKey="total_classificações"
                            fill="#007BC0"
                            activeBar={<Rectangle stroke="blue" />}
                            minPointSize={5}
                          >
                            {dataClassifications?.map(
                              (entry: { total_classificações: number }) => (
                                <>
                                  <Cell
                                    key={`cell-${entry.total_classificações}`}
                                    fill={
                                      entry.total_classificações === 0
                                        ? "#CCCCCC"
                                        : "#007BC0"
                                    }
                                  />
                                  <LabelList
                                    dataKey="total_classificações"
                                    position="top"
                                    fill={
                                      entry.total_classificações === 0
                                        ? "#CCCCCC"
                                        : "#007BC0"
                                    }
                                    style={{ fontSize: 16 }}
                                  />
                                </>
                              ),
                            )}
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    ) : (
                      <p className="no_results">Nenhum resultado encontrado.</p>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  background: "#fff",
                  width: "49%",
                  height: 380,
                  position: "relative",
                  paddingTop: "70px",
                  float: "left",
                  marginBottom: 15,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    overflowX: "auto",
                    overflowY: "hidden",
                    height: "100%",
                  }}
                >
                  <div className="title_dash">
                    <h2>Centro</h2>
                  </div>
                  <div
                    style={{
                      width: chartWidth,
                      height: "100%",
                      display: "flex",
                    }}
                  >
                    {Array.isArray(dataFromAPI) && dataFromAPI.length > 0 ? (
                      <ResponsiveContainer width="100%" height={350}>
                        <BarChart
                          data={data}
                          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                        >
                          <CartesianGrid horizontal={true} vertical={false} />
                          <XAxis dataKey="name" />
                          <YAxis
                            domain={[
                              0,
                              (dataMax: number) =>
                                Math.ceil(dataMax + dataMax * 0.05), // 5% a mais
                            ]}
                          />
                          <Tooltip />
                          <Bar
                            dataKey="total"
                            fill="#007BC0"
                            activeBar={<Rectangle stroke="blue" />}
                          >
                            <LabelList
                              dataKey="total"
                              position="top"
                              fill="#007BC0"
                              style={{ fontSize: 16 }}
                            />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    ) : (
                      <p className="no_results">Nenhum resultado encontrado.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DashboardTax;
